import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import AnimatedModal from "../../../AnimatedModal";
import { AppButton } from "../../AppButton";
import { AppOverlay } from "../../AppOverlay";
import CaregiverRankHeading from "./CaregiverRankHeading";

type Props = {
  icon: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["icon"];
  name: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["name"];
  wage: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["wage"];
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function CareMomentRankDemotionModal(props: Props) {
  return (
    <AppOverlay>
      <AnimatedModal.Styled isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <AnimatedModal.AnimationWrapper offset={0}>
          <Image src="/assets/wooden-blocks-arrow-table.jpg" alt="demotion" />
        </AnimatedModal.AnimationWrapper>
        <AnimatedModal.Headline>{translate(STRINGS.CHANGE_OF_RANKING)}</AnimatedModal.Headline>
        <AnimatedModal.Message>
          {translate(STRINGS.DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO)}
        </AnimatedModal.Message>

        <CaregiverRankHeading icon={props.icon} name={props.name} wage={props.wage} />

        <AnimatedModal.Message>
          {translate(
            STRINGS.CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK
          )}
        </AnimatedModal.Message>
        <AnimatedModal.Actions>
          <AppButton size="large" onClick={props.onRequestClose}>
            {translate(STRINGS.GOT_IT)}
          </AppButton>
        </AnimatedModal.Actions>
      </AnimatedModal.Styled>
    </AppOverlay>
  );
}

const Image = styled.img`
  max-height: 128px;
  max-width: 100%;
`;
